/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { CreateZoneFromJSON, CreateZoneToJSON } from './CreateZone';

/**
 * 
 * @export
 * @interface UpdateZoneInView
 */

/**
 * Check if a given object implements the UpdateZoneInView interface.
 */
export function instanceOfUpdateZoneInView(value) {
  if (!('zone' in value) || value['zone'] === undefined) return false;
  if (!('blockRID' in value) || value['blockRID'] === undefined) return false;
  return true;
}
export function UpdateZoneInViewFromJSON(json) {
  return UpdateZoneInViewFromJSONTyped(json, false);
}
export function UpdateZoneInViewFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    'zone': CreateZoneFromJSON(json['zone']),
    'blockRID': json['blockRID'],
    'viewId': json['viewId'] == null ? undefined : json['viewId'],
    'blockId': json['blockId'] == null ? undefined : json['blockId'],
    'containerRID': json['containerRID'] == null ? undefined : json['containerRID'],
    'plugins': json['plugins'] == null ? undefined : json['plugins']
  };
}
export function UpdateZoneInViewToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    'zone': CreateZoneToJSON(value['zone']),
    'blockRID': value['blockRID'],
    'viewId': value['viewId'],
    'blockId': value['blockId'],
    'containerRID': value['containerRID'],
    'plugins': value['plugins']
  };
}